// src/modules/app-views/account/pages/Subscription/components/EntityProfilesTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleTag from 'components/SimpleComponents/SimpleTag';
import translateX from 'utils/translateX';
import entitiesService from 'services/entitiesService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const EntityProfilesTag = ({ data, tags }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const items = tags || data?.entityProfile || [];

  const profileTags = items?.map((item, idx) => {
    const profileColor = entitiesService.getEntityProfileColor(item);
    return {
      key: idx,
      label: translateX(item?.toLowerCase()),
      color: profileColor,
      textColor: profileColor,
    };
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleTag tags={profileTags?.filter(i => i?.label)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EntityProfilesTag;

// *******************************************************************************
// HELPERS
// *******************************************************************************
